import { Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { AnppProducteurComponent } from './pages/anpp-producteur/anpp-producteur.component';

export const HOME_ROUTES: Routes = [
    {
        path: '',
        data: {
            role: 'ADMIN || ORGANISME || PI || PO || GP',
            domaines: ['VIN', 'ANPP'],
            menu: {
                icon: 'tachometer-alt',
                libelle: 'menu.home'
            }
        },
        component: HomeComponent
    },
    {
        path: ':idEntreprise',
        component: AnppProducteurComponent,
        children: [{ path: '', component: AnppProducteurComponent }]
    }
];
